function t(t, a) {
  return a(t), t;
}
export { t as default };